
function UserInsert() {
  return (
    <div>UserInsert</div>
  )
}

export default UserInsert